var map = {
	"./doc1_1.png": 2656,
	"./doc1_2.png": 8483,
	"./doc1_3.png": 3191,
	"./doc1_4.png": 4492,
	"./doc2_1.png": 9410,
	"./doc2_2.png": 9846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9872;